var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/martech/Homepage/HomePageBannerUpsell/HomePageBannerUpsell.js";

import React from 'react';
import PropTypes from 'prop-types';
import marked from 'marked';
import { Flex, Heading, Paragraph, Button, Box, Image } from '@zillow/constellation';

var themeStyles = function themeStyles(alternativeTheme) {
  return {
    backgroundColor: alternativeTheme ? '$colors.gray100' : '#136F65',
    headingHighlightColor: alternativeTheme ? '$colors.brand' : '#9FF17B',
    textColor: alternativeTheme ? 'textDark' : 'textWhite'
  };
};
/**
 * Homepage banner
 */


var HomePageBanner = function HomePageBanner(_ref) {
  var buttonText = _ref.buttonText,
      clickAction = _ref.clickAction,
      hoverAction = _ref.hoverAction,
      description = _ref.description,
      mediaImage = _ref.mediaImage,
      legalText = _ref.legalText,
      headlinePrefix = _ref.headlinePrefix,
      headlineSuffix = _ref.headlineSuffix,
      alternativeTheme = _ref.alternativeTheme;
  var styles = themeStyles(alternativeTheme);
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      backgroundColor: styles.backgroundColor,
      borderRadius: '20px'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Box, {
    as: Flex,
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    sx: {
      '@media $xs': {
        marginRight: '$spacing.md',
        marginLeft: '$spacing.md',
        flexDirection: 'column',
        paddingBottom: '$spacing.lg',
        alignItems: 'baseline'
      },
      '@media $xl': {
        marginRight: '80px',
        marginLeft: '80px',
        flexDirection: 'row',
        alignItems: 'center',
        paddingBottom: '$spacing.none'
      }
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      'max-width': '640px',
      'padding': '24px 0px 24px;'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    marginBottom: "sm",
    level: 3,
    fontColor: styles.textColor,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 21
    }
  }, headlinePrefix, ' ', /*#__PURE__*/React.createElement(Box, {
    as: "span",
    sx: {
      color: styles.headingHighlightColor
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 25
    }
  }, headlineSuffix)), /*#__PURE__*/React.createElement(Box, {
    sx: {
      'max-width': '426px'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(Paragraph, {
    fontColor: styles.textColor,
    dangerouslySetInnerHTML: {
      __html: marked.parseInline(description)
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 25
    }
  }))), /*#__PURE__*/React.createElement(Box, {
    as: Flex,
    sx: {
      '@media $xs': {
        alignItems: 'baseline'
      },
      '@media $xl': {
        alignItems: 'center'
      }
    },
    display: "flex",
    flexDirection: "column",
    gap: "md",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(Box, {
    as: Button,
    buttonType: "primary",
    inverse: !alternativeTheme,
    onClick: clickAction,
    onKeyDown: clickAction,
    onMouseEnter: hoverAction,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 21
    }
  }, buttonText), mediaImage && /*#__PURE__*/React.createElement(Box, {
    as: Flex,
    gap: "xs",
    display: "flex",
    flexDirection: "column",
    alignItems: "inherit",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(Box, {
    as: Image,
    sx: {
      'max-width': '212px'
    },
    src: mediaImage === null || mediaImage === void 0 ? void 0 : mediaImage.src,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 29
    }
  }), /*#__PURE__*/React.createElement(Paragraph, {
    fontType: "legal",
    fontColor: styles.textColor,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 29
    }
  }, legalText)))));
};

HomePageBanner.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Text on the button displayed in the component
   */
  buttonText: PropTypes.string.isRequired,

  /**
   * Action on clicking the component
   */
  clickAction: PropTypes.func.isRequired,

  /**
   * Action on hover over the component
   */
  hoverAction: PropTypes.func.isRequired,

  /**
   * Description displayed in the component
   */
  description: PropTypes.string.isRequired,

  /**
   * Heading displayed in the component
   */
  headlinePrefix: PropTypes.string.isRequired,

  /**
   * Legal text displayed at the bottom below the CTA button. Supports html.
   * If you want to update css, use class selector hp-banner-legal-text and apply css overrides
   */
  legalText: PropTypes.string,
  mediaImage: PropTypes.shape({
    /**
     * The alt text of the image.
     */
    alt: PropTypes.string,

    /**
     * The url of the image. This is used as an alternative to icon.
     */
    src: PropTypes.string
  }),
  headlineSuffix: PropTypes.string,
  alternativeTheme: PropTypes.bool
} : {};
HomePageBanner.defaultProps = {
  legalText: '',
  alternativeTheme: false
};
export default HomePageBanner;